import React from "react";
import HappayLoader from "@techsoftware/happay-widgets/Loader";
import Common from "../../constants/common";

const Loader = () => {
    const loaderProps = {
        id: "expense-loader",
        loader: true,
        loaderWrapperStyle: { background: "rgba(35, 52, 76, 0.5)" },
    };
    const isHdfc = Common._checkIfHdfcUrl();
    if (isHdfc) {
        loaderProps["imgSrc"] = "/assets/images/animation/blueSpinner.gif";
    }
    return (
        <HappayLoader
            {...loaderProps}
        />
    );
};

export default Loader;
